import React from 'react'

interface IPriceRange {
    label: string
    from: number
    to: number | null
}

interface IPriceRangeOptionsProps {
    /** Prefixo dos ids (o filtro aparece no desktop e no mobile). */
    idPrefix: string
    ranges: readonly IPriceRange[]
    priceFrom: number | null
    priceTo: number | null
    onChange: (from: number | null, to: number | null) => void
}

const CHECKBOX_CLASS = `checkbox-s appearance-none border border-dark-yellow bg-white h-5 w-5 rounded-md grid place-content-center before:content-[''] before:h-3 before:w-3 before:bg-destaques-hover before:rounded-full before:scale-0 lg:hover:before:bg-light-blue-inactive lg:hover:before:scale-100 checked:before:scale-100`

const Option: React.FC<{ id: string; label: string; checked: boolean; onChange: () => void }> = ({
    id,
    label,
    checked,
    onChange,
}) => (
    <div className={'form-group flex items-center mb-1'}>
        <input
            type="checkbox"
            name="rangePrice"
            id={id}
            className={CHECKBOX_CLASS}
            onChange={onChange}
            checked={checked}
        />
        <label htmlFor={id} className="flex select-none items-center justify-between p-0 ml-2 text-sm text-primary">
            {label}
        </label>
    </div>
)

/** Faixas de preço do filtro da listagem ("todos" tira a faixa). */
const PriceRangeOptions: React.FC<IPriceRangeOptionsProps> = ({ idPrefix, ranges, priceFrom, priceTo, onChange }) => (
    <div className="min-w-[210px] max-md:flex max-md:flex-col max-md:gap-3 mt-4">
        <Option
            id={`${idPrefix}-price-all`}
            label="todos"
            checked={priceFrom === null && priceTo === null}
            onChange={() => onChange(null, null)}
        />
        {ranges.map((range) => (
            <Option
                key={range.label}
                id={`${idPrefix}-price-${range.from}-${range.to ?? 'mais'}`}
                label={range.label}
                checked={priceFrom === range.from && priceTo === range.to}
                onChange={() => onChange(range.from, range.to)}
            />
        ))}
    </div>
)

export default PriceRangeOptions
